import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classPrivateFieldSet from "@babel/runtime/helpers/classPrivateFieldSet";
import _classPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

/*
 * Copyright 2020 New Relic Corporation. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
import { handle } from '../../../common/event-emitter/handle';
import { InstrumentBase } from '../../utils/instrument-base';
import { FEATURE_NAME } from '../constants';
import { globalScope } from '../../../common/constants/runtime';
import { eventListenerOpts } from '../../../common/event-listener/event-listener-opts';
import { now } from '../../../common/timing/now';
import { SR_EVENT_EMITTER_TYPES } from '../../session_replay/constants';
import { castError, castErrorEvent, castPromiseRejectionEvent } from '../shared/cast-error';

var _replayRunning = /*#__PURE__*/new WeakMap();

var _abort = /*#__PURE__*/new WeakSet();

export var Instrument = /*#__PURE__*/function (_InstrumentBase) {
  _inherits(Instrument, _InstrumentBase);

  var _super = _createSuper(Instrument);

  function Instrument(agentRef) {
    var _this$removeOnAbort, _this$removeOnAbort2;

    var _this;

    var auto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    _classCallCheck(this, Instrument);

    _this = _super.call(this, agentRef, FEATURE_NAME, auto);

    _abort.add(_assertThisInitialized(_this));

    _replayRunning.set(_assertThisInitialized(_this), {
      writable: true,
      value: false
    });

    try {
      // this try-catch can be removed when IE11 is completely unsupported & gone
      _this.removeOnAbort = new AbortController();
    } catch (e) {}

    _this.ee.on('internal-error', function (error) {
      if (!_this.abortHandler) return;
      handle('ierr', [castError(error), now(), true, {}, _classPrivateFieldGet(_assertThisInitialized(_this), _replayRunning)], undefined, _this.featureName, _this.ee);
    });

    _this.ee.on(SR_EVENT_EMITTER_TYPES.REPLAY_RUNNING, function (isRunning) {
      _classPrivateFieldSet(_assertThisInitialized(_this), _replayRunning, isRunning);
    });

    globalScope.addEventListener('unhandledrejection', function (promiseRejectionEvent) {
      if (!_this.abortHandler) return;
      handle('err', [castPromiseRejectionEvent(promiseRejectionEvent), now(), false, {
        unhandledPromiseRejection: 1
      }, _classPrivateFieldGet(_assertThisInitialized(_this), _replayRunning)], undefined, _this.featureName, _this.ee);
    }, eventListenerOpts(false, (_this$removeOnAbort = _this.removeOnAbort) === null || _this$removeOnAbort === void 0 ? void 0 : _this$removeOnAbort.signal));
    globalScope.addEventListener('error', function (errorEvent) {
      if (!_this.abortHandler) return;
      handle('err', [castErrorEvent(errorEvent), now(), false, {}, _classPrivateFieldGet(_assertThisInitialized(_this), _replayRunning)], undefined, _this.featureName, _this.ee);
    }, eventListenerOpts(false, (_this$removeOnAbort2 = _this.removeOnAbort) === null || _this$removeOnAbort2 === void 0 ? void 0 : _this$removeOnAbort2.signal));
    _this.abortHandler = _classPrivateMethodGet(_assertThisInitialized(_this), _abort, _abort2); // we also use this as a flag to denote that the feature is active or on and handling errors

    _this.importAggregator(agentRef);

    return _this;
  }
  /** Restoration and resource release tasks to be done if JS error loader is being aborted. Unwind changes to globals. */


  return _createClass(Instrument);
}(InstrumentBase);

function _abort2() {
  var _this$removeOnAbort3;

  (_this$removeOnAbort3 = this.removeOnAbort) === null || _this$removeOnAbort3 === void 0 ? void 0 : _this$removeOnAbort3.abort();
  this.abortHandler = undefined; // weakly allow this abort op to run only once
}

_defineProperty(Instrument, "featureName", FEATURE_NAME);

export var JSErrors = Instrument;